export interface HomePageCardPropTypes {
    children: JSX.Element;
    className?: string;
}

export default function HomePageCard({ children, className = '' }: HomePageCardPropTypes) {
    return (
        <div tabIndex={0} className={'db-cards' + ' ' + className}>
            {children}
        </div>
    );
}
